module.exports = vendor_af161589dfd2517ed5de;


//////////////////
// WEBPACK FOOTER
// external "vendor_af161589dfd2517ed5de"
// module id = 1
// module chunks = 1 2